import { render, staticRenderFns } from "./detailExamination.vue?vue&type=template&id=0b4c846a&scoped=true"
import script from "./detailExamination.vue?vue&type=script&lang=js"
export * from "./detailExamination.vue?vue&type=script&lang=js"
import style0 from "./detailExamination.vue?vue&type=style&index=0&id=0b4c846a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4c846a",
  null
  
)

export default component.exports